import React from 'react'
import {Grid, Show} from '@chakra-ui/react'

import {FanListSuspense} from './components/FanList'
import {GameList} from './components/GameList'

export function UserProfileIndexSuspense() {
  return <UserProfileIndex />
}

export function UserProfileIndex() {
  return (
    <Grid gap={4} templateColumns={{md: `3fr 1fr`}}>
      <GameList />
      <Show above="md">
        <FanListSuspense alignSelf="flex-start" />
      </Show>
    </Grid>
  )
}
